import ExampleSelectionDialog from "@/components/Widgets/types/ExamplesWidget/ExampleSelectionDialog";
import ExamplesWidgetProvider, {
  useExamples,
} from "@/components/Widgets/types/ExamplesWidget/example-widget-store";
import { DatasetSelect } from "@/components/Widgets/types/ExamplesWidget/selectors";
import {
  Dataset,
  Example,
} from "@/components/Widgets/types/ExamplesWidget/types";
import { useAuth } from "@/context/auth-context";
import { useUser } from "@/context/user-context";
import { useDatasetGroups } from "@/queries";
import { useEffect, useState } from "react";

interface DatasetPickerProps {
  onSelect?: (dataset: { id: number; row: number }) => void;
}

const MultiRowSelector = ({
  selectedDatasetId,
  onSelect,
}: {
  selectedDatasetId: number;
  onSelect?: (dataset: { id: number; row: number }) => void;
}) => {
  const examples = useExamples();

  useEffect(() => {
    examples.setSelectedDataset(selectedDatasetId?.toString() || "");
  }, [selectedDatasetId, examples]);

  const handleAddExample = (example: Example) => {
    examples.addExample(example);

    if (onSelect && selectedDatasetId) {
      onSelect({
        id: selectedDatasetId,
        row: examples.selectedExamples[0].id,
      });
    }
  };

  return selectedDatasetId ? (
    <ExampleSelectionDialog
      datasetId={selectedDatasetId}
      onAddExample={handleAddExample}
      singleSelect
      selectedExamples={examples.selectedExamples}
    />
  ) : null;
};

const DatasetPicker = ({ onSelect }: DatasetPickerProps) => {
  const { data, isLoading } = useDatasetGroups(
    useAuth()?.userToken!,
    Number(useUser()?.activeWorkspaceId),
  );

  const [datasetName, setDatasetName] = useState<string | undefined>();

  const dataset_groups = data?.dataset_groups || [];

  const selectedDatasetId = dataset_groups
    .find(({ name }: { name: string }) => name === datasetName)
    ?.datasets.sort(
      (a: Dataset, b: Dataset) => b.version_number - a.version_number,
    )[0]?.id;

  if (isLoading) return <div>Loading...</div>;

  return (
    <div className="flex flex-row items-center justify-center gap-2 ">
      <DatasetSelect
        autoFocus
        datasetGroups={dataset_groups}
        selectedDataset={datasetName}
        setSelectedDataset={setDatasetName}
        datasetId={selectedDatasetId}
      />

      {selectedDatasetId && (
        <ExamplesWidgetProvider>
          <MultiRowSelector
            selectedDatasetId={selectedDatasetId}
            onSelect={onSelect}
          />
        </ExamplesWidgetProvider>
      )}
    </div>
  );
};

export default DatasetPicker;
